export const generateIndexArray = (length: number) => [...Array(length).keys()];

export const updateArrayWithElements = <T extends { id: string | number }>(
  elements: T | T[],
  array: T[],
  remove = false,
  keyExtractor = (element: T) => element.id
) => {
  if (!Array.isArray(elements)) elements = [elements];

  const itemsMap = new Map(array.map(item => [keyExtractor(item), item]));

  for (const element of elements) {
    if (remove) itemsMap.delete(keyExtractor(element));
    else itemsMap.set(keyExtractor(element), element);
  }
  return Array.from(itemsMap.values());
};
